<template>
  <div>
    <h1>Retail Sales</h1>
    <hr>

    <!-- FILTER STARTS -->
    <flexibleFilter
      :dealer_type="'DEALER'"
      :fetch_filter="fetchFilter"
      @onFilter="setFilterUrl"
    ></flexibleFilter>
    <!-- FILTER ENDS -->

    <!-- STATS START -->
    <stats
      :filterUrl="filterUrl"
    ></stats>
    <!-- STATS END-->

    <!-- Top 10 Sales By Dealer Start -->
    <top-sales-by-dealer
      :filterUrl="filterUrl"
    ></top-sales-by-dealer>
    <!-- Top 10 Sales By Dealer End -->

    <!-- Top 10 Retail Sales By City Start -->
    <top-retail-sales-by-city
      :filterUrl="filterUrl"
    ></top-retail-sales-by-city>
    <!-- Top 10 Retail Sales By City End -->

    <!-- Top 10 Sales By Sub Series Start -->
      <top-sales-by-sub-series
      :filterUrl="filterUrl"
    ></top-sales-by-sub-series>
    <!-- Top 10 Sales By Sub Series End -->
  </div>
</template>

<script>
  import flexibleFilter from '@/components/filter/flexible_filter.vue'

  import stats from './children/stats'
  import topSalesByDealer from './children/topSalesByDealer'
  import topRetailSalesByCity from './children/topRetailSalesByCity'
  import topSalesBySubSeries from './children/topSalesBySubSeries'

  export default {
    data () {
      return {
        filterUrl : '',
        fetchFilter : 0,
      }
    },
    components : {
      flexibleFilter,
      stats,
      topSalesByDealer,
      topRetailSalesByCity,
      topSalesBySubSeries,
    },
    mounted () {
      this.fetchFilter++;
    },
    methods : {
      setFilterUrl(a){
        this.filterUrl = a
      }
    }
  }
</script>

<style scoped>
  
</style>